import Typo from '@/ui/typo/Typo';
import { Container, TitleWrapper, BtnWrapper, DescriptionWrapper } from './Title.styles';
import { COLORS } from '@/styles/colorTheme';

interface TitleProps {
  title?: string;
  desc?: string | string[];
  more?: string;
  onClick?: () => void;
  sx?: any;
}

const Title = ({ title, desc, more, onClick, sx }: TitleProps) => {
  const handleClick = () => {
    onClick();
  };

  return (
    <Container style={{ ...sx }} className="mb-6">
      <TitleWrapper>
        <div className="text-lg text-text-500">{title}</div>
        <BtnWrapper onClick={handleClick}>
          <div className="text-sm text-primary-500">{more}</div>
        </BtnWrapper>
      </TitleWrapper>

      {typeof desc === 'string' && (
        <div className="mt-1 hidden sm:block">
          <div className="text-sm text-text-200">{desc}</div>
        </div>
      )}

      {Array.isArray(desc) && (
        <div className="mt-1 hidden sm:block">
          {desc.map((el, i) => (
            <div key={i}>
              <div className="text-sm text-text-200">{el}</div>
            </div>
          ))}
        </div>
      )}
    </Container>
  );
};

export default Title;
